import { render, staticRenderFns } from "./PriceList.vue?vue&type=template&id=be1b6d58&scoped=true&"
import script from "./PriceList.vue?vue&type=script&lang=js&"
export * from "./PriceList.vue?vue&type=script&lang=js&"
import style0 from "./PriceList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PriceList.vue?vue&type=style&index=1&id=be1b6d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1b6d58",
  null
  
)

export default component.exports